import { LOCATION_CHANGE } from 'react-router-redux';
import { RequestStatus, defaults, entities } from 'typed/api';
import {
    childrenReducer, combineReducers, entityAddReducer, entityDeleteReducer, entityEditReducer, entityLoadAllReducer, entityLoadReducer,
    entityVoidAllReducer, networkActionReducer, sortableEntitiesReducer, switchReducers
} from './utils';
import { deepAssign } from 'typed/utils';

const
    ats = defaults.NetworkArrayOf(defaults.AgendaTheme),
    atsrs = defaults.NetworkArrayOf(defaults.AgendaTimeSerieRuleReport),
    atses: entities.AgendaTimeSerieEvent[] = [],
    atr = defaults.AgendaTimeReservation,
    atrs = defaults.NetworkArrayOf(atr),
    afs = defaults.NetworkArrayOf(defaults.AgendaFlag);

export default combineReducers({
    agendaThemes: sortableEntitiesReducer(ats, null, switchReducers(ats,
        entityLoadAllReducer(ats, 'LOAD_ALL_AGENDA_THEMES'),
        entityAddReducer(ats, 'ADD_AGENDA_THEME'),
        entityEditReducer(ats, 'EDIT_AGENDA_THEME'),
        entityDeleteReducer(ats, 'DELETE_AGENDA_THEME')
    )),
    agendaTimeSerieRules: switchReducers(atsrs,
        entityLoadAllReducer(atsrs, 'LOAD_ALL_AGENDA_TIME_SERIE_RULES'),
        entityLoadReducer(atsrs, 'LOAD_AGENDA_TIME_SERIE_RULE'),
        entityAddReducer(atsrs, 'ADD_AGENDA_TIME_SERIE_RULE'),
        entityEditReducer(atsrs, 'EDIT_AGENDA_TIME_SERIE_RULE'),
        entityDeleteReducer(atsrs, 'DELETE_AGENDA_TIME_SERIE_RULE'),
        childrenReducer(atsrs,
            combineReducers({
                Events: switchReducers(atses,
                    entityEditReducer(atses, 'EDIT_AGENDA_TIME_SERIE_EVENT'),
                    entityDeleteReducer(atses, 'DELETE_AGENDA_TIME_SERIE_EVENT'),
                    (state, action) => {
                        let nextState = state || atses;

                        if (action.type === 'CONTERT_AGENDA_TIME_SERIE_EVENT_TO_ENTITY') {
                            nextState = deepAssign(nextState, {
                                [nextState.getIndexByID(action.payload.entityID)]: {
                                    Custom: {
                                        status: action.payload.status
                                    }
                                }
                            });

                            if (action.payload.status === RequestStatus.SUCCEEDED) {
                                return deepAssign(nextState, {
                                    [nextState.getIndexByID(action.payload.entityID)]: {
                                        TargetEntityID: action.payload.response
                                    }
                                });
                            }
                        }

                        return nextState;
                    }
                )
            }),
            (state, action) => action.payload ? state.Data.getIndexByID(action.payload.parentID) : -1
        ),
        (state, action) => {
            const nextState = state || atsrs;

            if (action.type === 'DELETE_MEETING_SUCCESS') {
                return deepAssign(nextState, {
                    Data: nextState.Data.map(({ MeetingTemplateID, Events }) => ({
                        Events: Events.map(event => ({
                            TargetEntityID: !MeetingTemplateID || event.TargetEntityID !== (action as any).meetingID ?
                                event.TargetEntityID :
                                null
                        }))
                    }))
                });
            }

            if (action.type === 'DELETE_AGENDA_TIME_RESERVATION' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(nextState, {
                    Data: nextState.Data.map(({ TimeReservationID, Events }) => ({
                        Events: Events.map(event => ({
                            TargetEntityID: !TimeReservationID || event.TargetEntityID !== action.payload.entityID ?
                                event.TargetEntityID :
                                null
                        }))
                    }))
                });
            }

            if (action.type === 'DELETE_WORKSHOP' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(nextState, {
                    Data: nextState.Data.map(({ WorkshopID, Events }) => ({
                        Events: Events.map(event => ({
                            TargetEntityID: !WorkshopID || event.TargetEntityID !== action.payload.entityID ?
                                event.TargetEntityID :
                                null
                        }))
                    }))
                });
            }

            return nextState;
        }
    ),
    agendaTimeReservations: switchReducers(atrs,
        entityLoadAllReducer(atrs, 'LOAD_ALL_AGENDA_TIME_RESERVATIONS'),
        entityLoadReducer(atrs, 'LOAD_AGENDA_TIME_RESERVATION'),
        entityLoadReducer(atrs, 'RECREATE_AGENDA_TIME_RESERVATION'),
        entityAddReducer(atrs, 'ADD_AGENDA_TIME_RESERVATION'),
        entityEditReducer(atrs, 'EDIT_AGENDA_TIME_RESERVATION'),
        entityDeleteReducer(atrs, 'DELETE_AGENDA_TIME_RESERVATION'),
        entityVoidAllReducer(atrs, 'VOID_ALL_AGENDA_TIME_RESERVATIONS'),
        childrenReducer(atrs,
            networkActionReducer(atr, 'REQUEST_AGENDA_TIME_RESERVATION_CONVERSION'),
            (state, action) => action.payload ? state.Data.getIndexByID((action.payload as any).parentID || (action.payload as any).entityID) : -1
        ),
        (state, action) => {
            const nextState = state || atrs;

            if (action.type === 'DELETE_AGENDA_THEME' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(nextState, {
                    Data: nextState.Data.map(({ AgendaThemeID }) => ({ AgendaThemeID: AgendaThemeID !== action.payload.entityID ? AgendaThemeID : null }))
                });
            }

            if (action.type === 'EDIT_AGENDA_TIME_RESERVATION' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(nextState, {
                    Data: {
                        [nextState.Data.getIndexByID(action.payload.entityID)]: {
                            Updated: new Date()
                        }
                    }
                });
            }

            if (action.type === 'REQUEST_AGENDA_TIME_RESERVATION_CONVERSION' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(nextState, {
                    Data: {
                        [nextState.Data.getIndexByID(action.payload.entityID)]: {
                            ConversionInProgress: true
                        }
                    }
                });
            }

            return nextState;
        },
        entityVoidAllReducer(atrs, 'CONTERT_AGENDA_TIME_SERIE_EVENT_TO_ENTITY')
    ),
    agendaFlags: switchReducers(afs,
        entityLoadAllReducer(afs, 'LOAD_ALL_AGENDA_FLAGS'),
        entityAddReducer(afs, 'ADD_AGENDA_FLAG'),
        entityEditReducer(afs, 'EDIT_AGENDA_FLAG'),
        entityDeleteReducer(afs, 'DELETE_AGENDA_FLAG'),
        (state, action) => {
            const nextState = state || afs;

            if (action.type === 'DELETE_AGENDA_THEME' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(nextState, {
                    Data: nextState.Data.map(({ AgendaThemeID }) => ({ AgendaThemeID: AgendaThemeID !== action.payload.entityID ? AgendaThemeID : null }))
                });
            }

            return nextState;
        }
    ),
    calendarPeriod: (state, action) => {
        const defaultState = state || null;

        if (action.type === LOCATION_CHANGE && action.payload.pathname === '/management_calendar') {
            return +action.payload.query?.period || defaultState;
        }

        return state;
    }
});
